import { Button } from 'primereact/button'
import { Menu } from 'primereact/menu'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserAvatar } from './UserAvatar'

// import logo from '../../assets/images/gateway-logo.png'
// @ts-ignore
import mokailogo from '../../assets/images/gateway-logo.png'
// @ts-ignore
import startLogo from '../../assets/images/mokai-horizontal.svg'
// @ts-ignore
import mokailogo3 from '../../assets/images/mokai-logo-jelly.png'
// @ts-ignore
import mokailogo2 from '../../assets/images/mokai-logo.png'
// @ts-ignore
import { useAppSelector } from '../../redux/hooks'
import SidebarRoutes_Authorized, { MokaiRoute } from '../../router/routes'

import { openDokai } from '../../services/help/openDokai'
import { hasAnyRequiredClaim } from '../../util/validation/hasClaim'
import { OcrDrop } from '../content/ocr/FileDrop'

export const AppHeader = (): JSX.Element => {
  const menu = useRef<Menu>(null)

  const { loadedBasicInformation } = useAppSelector((state) => state.user)
  const userClaims = useAppSelector((state) => state.claims)
  const [navItems, setNavItems] = useState<any[]>([])

  const [logoStatus, setLogoStatus] = useState<number>()

  // t needs to be kept for correct translation in route
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [t] = useTranslation()

  const navigate = useNavigate()

  const location = useLocation()

  useEffect(() => {
    const sidebarItems = []
    //  todo verify
    // eslint-disable-next-line array-callback-return
    SidebarRoutes_Authorized.map((route: MokaiRoute) => {
      let requiredRoutes: string[] = [route.mainModule]
      if (route.subModules) {
        requiredRoutes = requiredRoutes.concat(route.subModules)
      }
      const userHasClaim = hasAnyRequiredClaim(userClaims, requiredRoutes)
      if (userHasClaim) {
        sidebarItems.push({
          label: t('navigation.' + route.name),
          // icon: route.icon,
          command: () => navigate(route.path),
        })
      }
    })
    sidebarItems.push({
      separator: true,
    })
    sidebarItems.push({
      label: 'Dokai',
      command: () => openDokai(location),
    })
    setNavItems(sidebarItems)
    // eslint-disable-next-line
  }, [loadedBasicInformation, userClaims])

  const changeLogo = (e: any): void => {
    switch (logoStatus) {
      case 1:
        setLogoStatus(2)
        e.currentTarget.src = mokailogo
        break
      case 2:
        setLogoStatus(3)
        e.currentTarget.src = mokailogo2
        break
      case 3:
        setLogoStatus(4)
        e.currentTarget.src = mokailogo3
        break
      default:
        setLogoStatus(1)
        e.currentTarget.src = startLogo
    }
  }

  return (
    <div
      className={
        'card p-menubar flex flex-wrap card-container mokai-gradient app-header'
      }
    >
      <Menu
        model={navItems}
        popup={true}
        ref={menu}
        className="header-popup-menu"
      />
      <Button
        type={'button'}
        icon={'fa-solid fa-bars'}
        className={
          'p-button-text p-button-raised p-button-rounded nav-burger mr-4 ml-0 mt-0 mb-0 pb-0 pt-0'
        }
        onClick={(event) => menu.current?.toggle(event)}
      />
      <img
        className={'gateway-mokai-logo'}
        style={{ height: '48px', width: 'auto', marginLeft: '-8px' }}
        alt={'Mokai'}
        onDoubleClick={(e) => changeLogo(e)}
        src={startLogo}
      />
      <div className="ml-auto mr-5 ">
        <div className={'ocr-drag-box'}>
          <OcrDrop />
        </div>
      </div>
      <UserAvatar />
    </div>
  )
}